export default __webpack_public_path__ + "static/media/tick-nightsky.5e26d154.svg";